import React from "react";
import MarketOverview from "../../components/MarketOverview";
import "./index.css";

const MarketOverviewPage = () => (
  <div className="mop-page">
    <div className="mop-wrap">
      <div className="mop-head">
        <h1 className="mop-title">Market Dashboard</h1>
        <p className="mop-sub">Live volume leaders, top gainers and losers on the Pakistan Stock Exchange.</p>
      </div>

      {/* on this page the panels are the destination, so no "View All" link */}
      <MarketOverview viewAll={null} />
    </div>
  </div>
);

export default MarketOverviewPage;
